import acl from 'app/bootstrap/acl';
import i18n from 'app/bootstrap/i18n';
import apollo from 'app/bootstrap/apollo';
import config from 'app/bootstrap/config';
import mixins from 'app/bootstrap/mixins';
import router from 'app/bootstrap/router';
import filters from 'app/bootstrap/filters';
import plugins from 'app/bootstrap/plugins';
import services from 'app/bootstrap/services';
import components from 'app/bootstrap/components';
import directives from 'app/bootstrap/directives';
import validation from 'app/bootstrap/validation';

export default[
    config,
    services,
    plugins,
    directives,
    components,
    mixins,
    filters,
    apollo,
    validation,
    i18n,
    acl,
    router
];
